export type NavUserType = 'member' | 'user' | 'admin' | 'all';

export interface NavItem {
  title: string;
  icon: string;
  to?: string;
  /** 라우트 이동 없이 새 창으로 여는 메뉴 */
  external?: 'ltcs-admin';
  minRole?: number;
  userType?: NavUserType;
  children?: NavItem[];
}

// ── 멤버(기관) 메뉴 ── role_level 10~30
export const MEMBER_NAVIGATION_ITEMS: NavItem[] = [
  { title: '대시보드', icon: 'mdi-view-dashboard-outline', to: '/m/dashboard' },
  {
    title: '자료요청',
    icon: 'mdi-cloud-download-outline',
    minRole: 90,
    children: [
      { title: '롱텀케어', icon: 'mdi-file-document-check-outline', to: '/m/request/ltcs', minRole: 90 },
      { title: '희망이음', icon: 'mdi-file-document-edit-outline', to: '/m/request/ces', minRole: 90 }
    ]
  },
  { title: '수급자관리', icon: 'mdi-account-heart-outline', to: '/m/beneficiary' },
  { title: '급여관리', icon: 'mdi-currency-krw', to: '/m/payroll' },
  {
    title: '재무회계',
    icon: 'mdi-calculator-variant-outline',
    children: [
      { title: '예산작성', icon: 'mdi-file-document-edit-outline', to: '/m/budget' },
      { 
        title: '회계관리', 
        icon: 'mdi-book-open-variant',
        children: [
          { title: '월별통장내역', icon: 'mdi-calendar-month', to: '/m/bankbook' },
          { title: '마감요청내역', icon: 'mdi-clipboard-check-outline', to: '/m/closing-history' },
          { title: '회계보고서류', icon: 'mdi-file-chart-outline', to: '/m/accounting-reports' }
        ]
      }
    ]
  },
  {
    title: '설정',
    icon: 'mdi-cog-outline',
    children: [
      { title: '기관정보', icon: 'mdi-office-building-cog', to: '/m/settings/info' },
      { title: '공지사항', icon: 'mdi-bullhorn-outline', to: '/m/notice' }
    ]
  },
  { title: '시설검색', icon: 'mdi-hospital-building', to: '/m/crawl-data', minRole: 50 }
];

// backward compat
export const NAVIGATION_ITEMS = MEMBER_NAVIGATION_ITEMS;

// ── 콘솔 메뉴 ── 매니저(60)는 minRole 80 미만, 관리자(80)·슈퍼바이저(100)는 아래 그룹까지
export const ADMIN_NAVIGATION_ITEMS: NavItem[] = [
  { title: '대시보드', icon: 'mdi-view-dashboard-outline', to: '/dashboard' },
  { title: '고객관리', icon: 'mdi-account-multiple-outline', to: '/member' },
  { title: '시설검색', icon: 'mdi-hospital-building', to: '/facility' },
  { title: '게시판', icon: 'mdi-bulletin-board', to: '/board' },
  { title: '설명회신청관리', icon: 'mdi-account-voice', to: '/briefing-applications', minRole: 60 },
  { title: '인사관리', icon: 'mdi-shield-account-outline', to: '/user', minRole: 80 },
  { title: '공휴일관리', icon: 'mdi-calendar-star', to: '/holiday-manage', minRole: 80 },
  { title: '직종관리', icon: 'mdi-badge-account-horizontal-outline', to: '/job-type-manage', minRole: 80 },
  { title: '상담요청관리', icon: 'mdi-message-text-outline', to: '/consult-requests', minRole: 80 },
  { title: '홍보', icon: 'mdi-bullhorn-outline', to: '/promo-mail-list', minRole: 80 },
  { title: '함우리몰관리', icon: 'mdi-open-in-new', external: 'ltcs-admin', minRole: 90 },
  { title: '크롤링 관리', icon: 'mdi-spider-web', to: '/crawl', minRole: 100 },
  { title: '인증서 관리', icon: 'mdi-certificate-outline', to: '/cert-manage', minRole: 100 },
  { title: '일정계획 변경 테스트', icon: 'mdi-calendar-edit', to: '/ltcs-schedule-probe', minRole: 100 },
];

// ── 레거시(미사용) — 비관리자는 StaffHome 허브 사용 ──
export const USER_NAVIGATION_ITEMS: NavItem[] = [];
